import React from 'react';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';

import {applicationMessage} from '../../actions/application';
import * as reportsActionCreators from '../../actions/reports';

function mapStateToProps(state) {
    return {
        reportsState : state.reports,
        territories : state.territories,
        coordinations : state.coordinations,
        users : state.users,
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({...reportsActionCreators, applicationMessage}, dispatch);
}

class Reports extends React.Component {

    componentWillReceiveProps(props) {
        var message = ((props.reportsState.xlsx || {}).requestData || {}).message;
        if(message) {
            this.props.applicationMessage('success', props.reportsState.xlsx.requestData.message);
            setTimeout(() => {
                this.props.clearXlsxData();
            }, 3000);
        }
    }

    render() {
        return React.cloneElement(this.props.children, this.props);
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Reports);


/** WEBPACK FOOTER **
 ** ./src/components/containers/Reports.jsx
 **/